export enum EnumMessageToDisplayType {
    info,
    warning,
    error,
    question,
    success
}
